/**
 * @file: ChannelSegment.tsx
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 *
 * The follow-up channel picker — a full-rounded segment control in the
 * lead-detail brand voice.
 */

import { LD } from '@euler/app/flows/leads/pages/detail/components/leadDetailKit';
import { SegmentControl } from '@euler/components/SegmentControl';
import { FontFamily } from '@euler/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { LeadActivityChannelLabel } from '@euler/model/lead/LeadActivity';
import { SelectableChannel, kChannels } from '../functions/channels';

export const ChannelSegment = ({
  channel,
  onChange,
}: {
  channel: SelectableChannel;
  onChange: (next: SelectableChannel) => void;
}) => {
  const { rpx } = useResponsiveContext();
  return (
    <SegmentControl
      segments={kChannels.map(c => LeadActivityChannelLabel[c])}
      selectedIndex={kChannels.indexOf(channel)}
      onSelectedIndexChange={i => onChange(kChannels[i])}
      style={{
        height: rpx(40),
        backgroundColor: LD.hairline,
        borderRadius: rpx(100),
      }}
      sliderStyle={{
        backgroundColor: LD.brand,
        borderRadius: rpx(100),
      }}
      textStyle={{
        color: LD.steel,
        fontSize: rpx(14),
        lineHeight: rpx(20),
        fontFamily: FontFamily.NotoSans.Medium,
      }}
      activeTextStyle={{
        color: '#fff',
        fontSize: rpx(14),
        lineHeight: rpx(20),
        fontFamily: FontFamily.NotoSans.Bold,
      }}
    />
  );
};
